import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
    CampoFormularioEstruturaModel,
    CampoFormularioModel
} from '../../../../../../../../../model/planilhas/campo-formulario.model';
import {PreenchFormularioDadosModel} from '../../../../../../../../../model/planilhas/preench-form.model';
import {GatilhoCondicional} from '../../../../../../../../../model/planilhas/GatilhoCondicional';
import {_ListEmittedModel} from '../../ui-checklist-group-fields.component';

@Component({
    selector: 'ui-checklist-boolean-field',
    standalone: false,
    templateUrl: './ui-checklist-boolean-field.html',
    styleUrl: './ui-checklist-boolean-field.scss'
})
export class UiChecklistBooleanField {
    @Input() group: CampoFormularioModel;
    @Input() field: CampoFormularioEstruturaModel;
    @Input() data: PreenchFormularioDadosModel;
    @Input() triggers: GatilhoCondicional[];

    @Output() groupTriggerChange = new EventEmitter<_ListEmittedModel>();

    validateConditional() {
        if (!this.field.cond_item) return;

        const aux = this.field.cond_item.split(',') as Array<String>;

        if (Array.isArray(this.data.valor)) {
            return aux?.some(cond => this.data.valor?.includes(cond));
        } else {
            return aux?.some(cond => this.data.valor === cond);
        }
    }

    selectItem(item: string) {
        if (this.data.valor === item) {
            this.data.valor = undefined;

            return;
        }
        this.data.valor = item;

        if (this.hasConditional(item)) {
            this.showConditionalGroup(item);
        }
    }

    isInconsistency(value: string) {
        return this.field.valores_com_inconsistencia?.some(inc => inc === value);
    }

    hasConditional(item: string) {
        return !!this.getTrigger(item);
    }

    hasTriggeredConditional(item: string) {
        return this.hasConditional(item) && this.wasSelected(item);
    }

    showConditionalGroup(item: string) {
        const trigger = this.getTrigger(item);

        if (!trigger) return;

        this.groupTriggerChange.emit({
            trigger,
            field: this.field,
            data: this.data
        });
    }

    private getTrigger(item: string) {
        return this.triggers.find(gat =>
            gat.gatilho_campo_formulario_id === this.group.id
            && (gat.gatilho_regra.valor ? this.field.valor_principal : this.field.valor_secundario) === item.toUpperCase()
            && gat.gatilho_campo_ordem === this.field.id
        );
    }

    wasSelected(item: string) {
        if (Array.isArray(this.data.valor)) {
            return this.data.valor?.some((value) => value === item);
        }

        return this.data.valor === item;
    }

    getHighlightColor(wasSelected: boolean, isInconsistency: boolean, hasCondicional: boolean) {
        if (wasSelected) {
            if (hasCondicional) {
                return 'warning';
            }

            return isInconsistency ? 'danger' : 'secondary';
        }

        return 'warning';
    }
}
